module.exports = __webpack_public_path__ + "static/media/Card__exportData--dark.b4a6eb3f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Card__exportData--dark.svg
// module id = 1101
// module chunks = 0